import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTicketCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={54}
    height={54}
    fill="none"
    {...props}
  >
    <circle cx={27} cy={27} r={27} fill="#776BFF" opacity={0.1} />
    <path
      fill="url(#TicketCircle_svg__a)"
      fillRule="evenodd"
      d="M34.408 21.904a3.27 3.27 0 0 1 3.397.788 3.2 3.2 0 0 1 0 4.52l-10.58 10.592a3.19 3.19 0 0 1-4.513 0 3.29 3.29 0 0 1-.787-3.401 1.816 1.816 0 0 0-2.32-2.322 3.28 3.28 0 0 1-3.396-.789 3.2 3.2 0 0 1 0-4.52l3.249-3.254.002-.001.001-.001 7.327-7.336a3.233 3.233 0 0 1 5.3 3.402 1.818 1.818 0 0 0 2.32 2.322m-12.692 3.778a1.2 1.2 0 0 1 1.697 0l1.998 1.998a1.2 1.2 0 0 1-1.697 1.697l-1.998-1.998a1.2 1.2 0 0 1 0-1.697m6.23 4.634a1.2 1.2 0 1 0-1.709 1.685l.475.482a1.2 1.2 0 1 0 1.709-1.686z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="TicketCircle_svg__a"
        x1={41.5}
        x2={10.996}
        y1={23}
        y2={30.482}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D4D3FF" />
        <stop offset={1} stopColor="#776BFF" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgTicketCircle;
